<template>
  <div id="app">
    <Header v-if="showHeader"></Header>
    <transition name="fade" v-if="loading">
      <div class="loading">
        <Loading type="spinner" color="#06CCBF" vertical size="42px">{{ $t('empty.loading') }}</Loading>
      </div>
    </transition>
    <router-view v-else />
  </div>
</template>

<script>
import { Loading } from 'vant';
import Header from '@/components/header.vue';
export default {
  components: { Loading, Header },
  computed: {
    loading() {
      return !this.$store.state.auth.status;
    },
    id() {
      return this.$route.params.id;
    },
    pathName() {
      return this.$route.name;
    },
    showHeader() {
      return this.$route.meta.header !== false;
    }
  },
  methods: {
    initData() {
      this.$store.dispatch('getInfo', this.id).then(res => {
        if (!res) {
          this.$router.push('/');
        }
      });
    },
    initUserInfo() {
      let userInfo = sessionStorage.getItem('userInfo');
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
        this.$store.commit('userUpdate', userInfo);
      }
    },
  },
  // watch: {
  //   $route: "initData"
  // },
  created() {
    this.initUserInfo();
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="less" scoped>
.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 750px;
  height: 750px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
